export const environment = {
  VERSION: '2.4.0-dev',
  HOST: 'https://dev.mymindlog.com',
  SUPABASE_URL: 'https://tppzfwbftxxbpccihjis.supabase.co',
  SUPABASE_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRwcHpmd2JmdHh4YnBjY2loamlzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTkyMzUxMDcsImV4cCI6MjA3NDgxMTEwN30.-UjAdM_p4bw7xFPHJ8qn0nf1GhDJZTCf9Zuv-4Qowdw',
  STRIPE_PRICE_PLANS: {
    PROFESSIONAL: 'price_1SSETVRARhnCg7U3lUl2E8a7',
    PROFESSIONAL_FREE: 'price_1SVgO8RARhnCg7U3bGyMoIXx'
  },
  VAPID_PUBLIC_KEY: 'BFB6-sh-UNKC1IVut2yU9W5ZU96u7PR0JckB14ff4qK1LcxPui2Lg1Zgp9eFjuPE__z0YgPEXa3A_vHLXFLUisc'
};
